
const PDGParticleReducer = (state = { particles: null }, action) => {
    if (action.type === 'SET_PDG_PARTICLES') {
        return {particles: action.payload };
    }
    return state;
}
export default PDGParticleReducer;